export default {
    url:'https://www.snecompany.com',
    name: '(주) 에스앤이컴퍼니',
    number: '사업자등록번호: 737-88-01827',
    register: '통신판매업 신고: 제 2020-서울종로-1787호',
    responsibility: '개인정보관리 책임자: 장세훈 (shjang@bgood.co.kr)',
    tel: '전화: 02-3276-2812',
    email: '이메일: contact@bgood.co.kr',
    address: '주소: 서울특별시 종로구 새문안로92, 1905호'
}